var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEdited = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.839 1.707a1 1 0 0 1 1.414 0l.707.707a1 1 0 0 1 0 1.414l-.707.708-2.121-2.122zM9.425 3.121l2.12 2.122-6.27 6.271a.4.4 0 0 1-.222.113l-1.98.31a.3.3 0 0 1-.343-.343l.31-1.98a.4.4 0 0 1 .113-.22z"
})));
export default SvgEdited;